import React, { Component } from 'react';
import { Link } from "react-router-dom";

class Index extends Component {
  render() {
    return (
      <div>
        <h1 className="mb-3">Index of Pages</h1>

        <h3>Merchant Portal</h3>
        <ul className="mb-3">
          <li><Link to="/sign-in">Sign In</Link></li>
          <li><Link to="/dashboard">Dashboard</Link></li>
          <li><Link to="/applications">Applications</Link></li>
          <li>Application Detail
            <ul>
              <li><Link to="/application/detail">Application Detail</Link></li>
              <li><Link to="/application/detail/approved">Application Detail – Approved</Link> (w/ Refund Request)</li>
            </ul>
          </li>
          <li>Select Offer
            <ul>
              <li><Link to="/application/select-offer">Select Offer</Link></li>
              <li><Link to="/application/select-offer?verification">Select Offer - Verification Required</Link></li>
            </ul>
          </li>
          <li><Link to="/application/income-verification">Income Verification</Link></li>
          <li><Link to="/text-to-apply">Text to Apply</Link></li>
          <li><Link to="/profile">Profile</Link></li>
          <li><Link to="/brochures">Request Brochures</Link></li>
          <li><Link to="/resource-center">Resource Center</Link></li>
        </ul>

        <h3>Apply - DTC</h3>
        <ol className="mb-3">
          <li><Link to="/dtc/apply">Apply</Link></li>
          <li><Link to="/dtc/merchant">Find Merchant</Link></li>
          <li>Loan Decision
            <ul>
              <li><Link to="/dtc/approved">Pre-Approved</Link></li>
              <li><Link to="/dtc/declined">Declined</Link></li>
              <li><Link to="/dtc/declined-offer">Declined - Offer – Freshstart</Link></li>
              <li><Link to="/dtc/declined-offer-aff">Declined - Offer – AFF</Link></li>
            </ul>
          </li>
          <li>Two-step Verification
            <ul>
              <li><Link to="/dtc/2fa">Choose Method</Link></li>
              <li><Link to="/dtc/2fa/text">Text Verification</Link></li>
              <li><Link to="/dtc/2fa/call">Phone Call Verification</Link></li>
            </ul>
          </li>
          <li>Reprompt
            <ul>
              <li><Link to="/dtc/verify/lastname">Last Name</Link></li>
              <li><Link to="/dtc/verify/ssn">SSN</Link></li>
              <li><Link to="/dtc/verify/text-link">Text Link</Link></li>
              <li><Link to="/dtc/verify/id-upload">ID Upload</Link></li>
            </ul>
          </li>
          <li><Link to="/dtc/loan-offer">Loan Offer</Link></li>
          <li><Link to="/dtc/autopay">Auto-Pay Election</Link></li>
          <li><Link to="/dtc/sign">Sign Loan Agreement</Link></li>
          <li><Link to="/dtc/complete">Complete</Link></li>
        </ol>

        <h3>Apply – Personify</h3>
        <ul>
          <li><Link to="/personify/decline-start">Decline – Start</Link></li>
          <li><Link to="/personify/consent">Consent</Link></li>
          <li><Link to="/personify/income">Income</Link></li>
          <li><Link to="/personify/approved">Approved</Link></li>
          <li><Link to="/personify/select-offer">Select Offer</Link></li>
          <li><Link to="/personify/ach">ACH Enroll</Link></li>
          <li><Link to="/personify/confirm">Confirm Offer</Link></li>
          <li><Link to="/personify/security">Security</Link></li>
          <li><Link to="/personify/kba">Security KBA</Link></li>
          <li><Link to="/personify/pending">Agreement Signature Pending</Link></li>
          <li><Link to="/personify/sign">Sign Agreement</Link></li>
          <li><Link to="/personify/decline">Declined</Link></li>
        </ul>

        <h3>Corporate Portal</h3>
        <ul>
          <li><Link to="/corp/dashboard">Dashboard</Link></li>
          <li><Link to="/corp/applications">Applications</Link></li>
          <li><Link to="/corp/merchants">Merchants</Link>
            <ul>
              <li><Link to="/corp/merchant-detail">Merchant Detail</Link></li>
              <li><Link to="/corp/merchant-refunds">Merchant Detail – Refunds</Link></li>
            </ul>
          </li>
        </ul>

        <h3>Consumer Portal</h3>
        <ul>
          <li><Link to="/consumer/signin">Sign In</Link></li>
          <li><Link to="/consumer/create-account">Create Account</Link></li>
          <li><Link to="/consumer/forgot-password">Forgot Password</Link></li>
          <li><Link to="/consumer/dashboard">Dashboard</Link>
            <ul>
              <li><Link to="/consumer/dashboard?pastdue">Dashboard – Past Due</Link></li>
              <li><Link to="/consumer/dashboard?error">Dashboard – Payment Error</Link></li>
            </ul>
          </li>
          <li><Link to="/consumer/loans">My Loans</Link></li>
          <li><Link to="/consumer/documents">Documents</Link></li>
          <li><Link to="/consumer/settings">Settings</Link></li>
        </ul>
      </div>
    );
  }
}

export default Index;
